import React, { Component } from "react";
import { connect } from "react-redux";
import CircularProgress from '@material-ui/core/CircularProgress';
// import {
//   MARKER_SELECTING,
// } from "../../../reducers/map";

class MapLoadingBox extends Component {
  componentWillUpdate(nextProps, nextState) {}

  render() {
    return (
      <div style={{ position: "absolute", top: 0, left: 0, right: 0, bottom: 0, display: "flex", alignItems: "center", justifyContent: "center", pointerEvents: "none", zIndex: 1000 }}>
          <div style={{ background: "transparent" }}>
            {/* <center>Please wait...</center> */}
            <CircularProgress size={'100px'} />
          </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    map_loading: state.map.map_loading
    // marker_selecting: state.map.marker_selecting
  };
};

const mapActionsToProps = {
//   MARKER_SELECTING : MARKER_SELECTING,
//   MARKER_MOVE : mapMoveMarker
};

export default connect(
  mapStateToProps,
  mapActionsToProps
)(MapLoadingBox);
